import { useState, useEffect } from 'react';
import './VisaApp.css';
import ImageGallery from './imageGallery 2';
import BillPayment from './BillPayment 2';

import plus from "../assets/+.png"
import Group1090 from "../assets/Group 1090.png"

function VisaApp() {
  const [tab, setTab] = useState(Array(5).fill(0));
  const [member, setMember] = useState(1); 
  const [isLoading, setIsLoading] = useState(true);
  const [submittedTravelers, setSubmittedTravelers] = useState([]); 
  const [travelersData, setTravelersData] = useState([]);
  const [visaData, setVisaData] = useState({
    location: 'India', // Default data
    visaType: 'Test',  // Default data
  });
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchVisaData = async () => {
      try {
        const response = await fetch('/api/visa-data'); // Replace with your API endpoint
        if (!response.ok) {
          throw new Error('Failed to fetch visa data');
        }
        const data = await response.json();
        setVisaData({
          location: data.location || 'India', // Fallback to default if API doesn't return location
          visaType: data.visaType || 'Test', // Fallback to default if API doesn't return visaType
        });
      } catch (err) {
        console.error('Error fetching visa data:', err);
        setError(true); // Set error state
      }
    };

    fetchVisaData();
  }, []);

  const getInitialFormData = () => ({
    firstName: '',
    lastName: '',
    contact: '',
    dob: '',
    email: '',
    birthPlace: '',
    nationality: '',
    sex: '',
    maritalStatus: '',
    passportNo: '',
    panNo: '',
    passportIssuedOn: '',
    passportValidUntil: '',
    documents: {
      passport: [],
      photo: [],
      other: [],
    },
  });

  useEffect(() => {
    const fetchTravelersCount = async () => {
      setIsLoading(true);
      try {
        const response = await fetch('https://api.example.com/travelers/count');
        
        if (!response.ok) {
          throw new Error('Failed to fetch travelers count');
        }
        
        const data = await response.json();
        const count = data.count || 1; // Fallback to 1 if count is not provided
        
        setMember(count);

        const initialTravelersData = Array(count).fill().map(() => getInitialFormData());
        setTravelersData(initialTravelersData);
        
      } catch (error) {
        console.error('Error fetching travelers count:', error);
        const initialTravelersData = Array(5).fill().map(() => getInitialFormData());
        setTravelersData(initialTravelersData);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTravelersCount();
  }, []);

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    
    setTravelersData(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        [name]: value,
      };
      return newData;
    });
  };

  const handleFileChange = (index, e) => {
    const { name, files } = e.target;
    
    setTravelersData(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        documents: {
          ...newData[index].documents,
          [name]: files,
        },
      };
      return newData;
    });
  };

  const handleSubmit = async (index) => {
    try {
      // Show loading state
      setIsLoading(true);
      
      // Prepare form data for submission
      const travelerData = travelersData[index];
      
      // Create FormData object for file upload
      const formData = new FormData();
      
      // Add all regular fields
      Object.keys(travelerData).forEach(key => {
        if (key !== 'documents') {
          formData.append(key, travelerData[key]);
        }
      });
      
      // Add documents to FormData
      Object.keys(travelerData.documents).forEach(docType => {
        if (travelerData.documents[docType].length > 0) {
          Array.from(travelerData.documents[docType]).forEach(file => {
            formData.append(`${docType}`, file);
          });
        }
      });
      
      // Make API call to submit data
      const response = await fetch('https://api.example.com/travelers/submit', {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Failed to submit traveler data');
      }
      
      // Mark this traveler as submitted
      setSubmittedTravelers(prev => [...prev, index]);
      
      // Close current tab and open next one if available
      handleTabChange(index, 0);
      if (index < member - 1) {
        handleTabChange(index + 1, 1);
      }
      
      console.log(`Traveler ${index + 1} data submitted successfully`);
      
    } catch (error) {
      console.error(`Error submitting traveler ${index + 1} data:`, error);
      alert(`Failed to submit data for Traveler ${index + 1}. Please try again.`);
    } finally {
      setIsLoading(false);
    }
  };

  const getTodayDate = () => new Date().toISOString().split('T')[0];

  const handleTabChange = (index, newTab) => {
    // Prevent reopening already submitted forms
    if (submittedTravelers.includes(index) && newTab === 1) {
      alert("This traveler's information has already been submitted and cannot be edited.");
      return;
    }
    
    const newTabs = [...tab];
    newTabs[index] = newTab;
    setTab(newTabs);
  };

  if (isLoading && travelersData.length === 0) {
    return <div className="loading">Loading travelers information...</div>;
  }

  return (
    <div className='visa-app'>
      <ImageGallery />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
        className="contentarea"
      >
        <div style={{ width: '60%', margin: '15px' }}>
          <div>
            <div className="sectiontitle">
              Application
              <span> Form</span>
            </div>

            <div className="visaapplicationdetail">
              <div className="visaapplicationdata">
                <div className="visaformrow1">Location</div>
                <div className="visaformrow2" >{visaData.location}</div>
              </div>

              <div className="visaapplicationdata">
                <div className="visaformrow1" >Visa Type</div>
                <div className="visaformrow2" >{visaData.visaType}</div>
              </div>
            </div>

            {travelersData.map((travelerData, index) => (
              <div className="visaapplicationdetailform" key={`traveller-${index}`}>
                {tab[index] === 0 ? (
                  <div>
                    <div
                      onClick={() => handleTabChange(index, 1)}
                      style={{
                        backgroundColor: submittedTravelers.includes(index) ? '#4a3070' : '#321e5d',
                        color: 'white',
                        padding: '15px',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="traveller-title">
                        Traveller {index + 1} {index === 0 ? '(Primary Customer)' : ''}
                        {submittedTravelers.includes(index) ? ' (Submitted)' : ''}
                      </span>
                      {!submittedTravelers.includes(index) && (
                        <div>
                          <img src={plus} alt="Add icon" />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div
                      onClick={() => handleTabChange(index, 0)}
                      style={{
                        backgroundColor: '#321e5d',
                        color: 'white',
                        padding: '15px',
                        borderTopLeftRadius: '30px',
                        borderTopRightRadius: '30px',
                        cursor: 'pointer',
                      }}
                    >
                      <span className="traveller-title">
                        Traveller {index + 1} {index === 0 ? '(Primary Customer)' : ''}
                      </span>
                    </div>
                    <div className="visaapplicationforminputcontainer">
                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">First Name</label>
                          <input
                            className="visaformrow2"
                            name="firstName"
                            value={travelerData.firstName}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Last Name</label>
                          <input
                            className="visaformrow2"
                            name="lastName"
                            value={travelerData.lastName}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Contact</label>
                          <input
                            className="visaformrow2"
                            name="contact"
                            value={travelerData.contact}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Date of Birth</label>
                          <input
                            className="visaformrow2"
                            name="dob"
                            type="date"
                            value={travelerData.dob}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            max={getTodayDate()}
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Email</label>
                          <input
                            className="visaformrow2"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            value={travelerData.email}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Birth Place</label>
                          <input
                            className="visaformrow2"
                            name="birthPlace"
                            type="text"
                            placeholder="Enter your place of birth"
                            value={travelerData.birthPlace}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Nationality</label>
                          <input
                            className="visaformrow2"
                            name="nationality"
                            value={travelerData.nationality}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Sex</label>
                          <select
                            className="visaformrow2"
                            name="sex"
                            value={travelerData.sex}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          >
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Marital Status</label>
                          <select
                            className="visaformrow2"
                            name="maritalStatus"
                            value={travelerData.maritalStatus}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          >
                            <option value="">Select</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                          </select>
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Passport no.</label>
                          <input
                            className="visaformrow2"
                            type="text"
                            name="passportNo"
                            value={travelerData.passportNo}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Pan no.</label>
                          <input
                            className="visaformrow2"
                            type="text"
                            name="panNo"
                            value={travelerData.panNo}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>

                      <div className="visaapplicationformrow">
                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Passport Issued On</label>
                          <input
                            className="visaformrow2"
                            type="date"
                            name="passportIssuedOn"
                            value={travelerData.passportIssuedOn}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>

                        <div className="visaapplicationrowinput">
                          <label className="visaformrow1">Passport Valid Until</label>
                          <input
                            className="visaformrow2"
                            type="date"
                            name="passportValidUntil"
                            value={travelerData.passportValidUntil}
                            onChange={(e) => handleInputChange(index, e)}
                            required
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      </div>


                    </div>
                    
                    <div className="upload-section">
                      <div style={{marginLeft:'50px',fontWeight:'700'}}>Upload Documents</div>
                    </div>

                    <div className="visaapplicationformrow">
                      {['passport', 'photo', 'other'].map((docType) => (
                        <div className="visa-app-form-group" key={docType}>
                          <label>
                            {docType.charAt(0).toUpperCase() + docType.slice(1)}* 
                            <img src={Group1090} alt={`${docType} icon`} />
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            name={docType}
                            onChange={(e) => handleFileChange(index, e)}
                            disabled={submittedTravelers.includes(index)}
                          />
                        </div>
                      ))}
                    </div>

                    {!submittedTravelers.includes(index) && (
                      <button
                        type="button"
                        style={{
                          backgroundColor: '#541c9c',
                          color: 'white',
                          padding: '10px',
                          borderRadius: '30px',
                          cursor: 'pointer',
                          width: '100px',
                          margin: '20px',
                        }}
                        onClick={() => handleSubmit(index)}
                        disabled={isLoading}
                      >
                        {isLoading ? 'Uploading...' : 'Upload'}
                      </button>
                    )}
                  </form>
                )}
              </div>
            ))}
          </div>
        </div>
        <div style={{width: '35%'}}>
          <BillPayment />
        </div>
      </div>
    </div>
  );
}

export default VisaApp;